import usePublicDefinition from '../usePublicDefinition'

const EMPTY = { questionnaires: [], fields: [], researches: [], moments: [], options: {}, matrixRows: {}, matrixColumns: {} }

/**
 * De definitie van één openbare vragenlijst, via `getPublicQuestionnaire`. De
 * pagina las Questionnaires, QuestionnaireFields, Research, MeasureMoments en de
 * opties tot 2026-11-04 zelf, wat alleen kon omdat iedereen die collecties
 * mocht lezen.
 *
 * @param {{client: string, questionnaireId: string, researchId?: string, momentId?: string}} link
 * @returns {{data: import('../../StateManagment/PublicQuestionnaireContext').PublicQuestionnaireData|null, error: {code?: string, message?: string}|null}}
 */
const usePublicQuestionnaire = ({ client, questionnaireId, researchId, momentId }) => usePublicDefinition(
    'getPublicQuestionnaire',
    client && questionnaireId
        ? { client, questionnaireId, researchId: researchId || '', momentId: momentId || '' }
        : null,
    EMPTY
)

export default usePublicQuestionnaire
